import {Button, Grid, Typography} from '@mui/material';

const QuizAnswerButton = ({ 
  answer, 
  isSelected, 
  isCorrect, 
  hasAnswered, 
  showResult, 
  onSelect,
  disabled
}) => {
  const getBackgroundColor = () => {
    if (showResult) {
      if (isCorrect) {
        return 'linear-gradient(135deg, rgba(46, 125, 50, 0.95) 0%, rgba(67, 160, 71, 0.95) 100%)';
      }
      if (isSelected && !isCorrect) {
        return 'linear-gradient(135deg, rgba(198, 40, 40, 0.95) 0%, rgba(211, 47, 47, 0.95) 100%)';
      }
    } else if (isSelected) {
      return 'linear-gradient(135deg, rgba(28, 39, 60, 0.95) 0%, rgba(45, 55, 72, 0.95) 100%)';
    }
    return 'rgba(28, 39, 60, 0.6)';
  };

  const classes = ['glass'];
  if (!hasAnswered && !disabled) classes.push('hover-scale');
  if (showResult && isCorrect) classes.push('animate-pulse');

  return (
    <Grid item xs={12} sm={6}>
      <Button
        fullWidth
        variant={isSelected ? "contained" : "outlined"}
        onClick={onSelect}
        disabled={disabled || hasAnswered}
        className={classes.join(' ')}
        sx={{
          minHeight: 80,
          transition: 'all 0.3s ease',
          background: getBackgroundColor(),
          backdropFilter: 'blur(10px)',
          border: '1px solid',
          borderColor: showResult && isCorrect ? 'rgba(76, 175, 80, 0.5)' : 'rgba(255, 255, 255, 0.1)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
            opacity: 0,
            transition: 'opacity 0.3s ease'
          },
          '&:hover': {
            background: getBackgroundColor(),
            '&::before': {
              opacity: !disabled && !hasAnswered ? 1 : 0
            }
          },
          '&.Mui-disabled': {
            background: getBackgroundColor(),
            color: showResult ? 'var(--color-text-primary)' : 'var(--color-text-disabled)',
            opacity: 1,
            borderColor: showResult && isCorrect ? 'rgba(76, 175, 80, 0.5)' : 'rgba(255, 255, 255, 0.1)'
          },
          animation: showResult && (
            isCorrect ? 'pulse 2s infinite' : 
            (isSelected && !isCorrect) ? 'shake 0.5s ease-in-out' : 'none'
          )
        }}
      >
        <Typography 
          variant="body1"
          sx={{
            color: 'var(--color-text-primary)',
            fontWeight: (showResult && isCorrect) || isSelected ? 'bold' : 'normal',
            transition: 'all 0.3s ease',
            position: 'relative',
            zIndex: 1,
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}
        >
          {answer}
        </Typography>
      </Button>
    </Grid>
  );
};

export default QuizAnswerButton; 